import {
  ReviewAlertFooterService,
  TrustPilotModal,
} from "@origin-digital/platform-personalisation";
import * as React from "react";
import { useEffect } from "react";
import { KrakenAppContent, UnauthAppContent } from "../AppContent";
import { CrisisBanner } from "../Banner";
import { SkipLink } from "../SkipLink";
import { SuppressAndroidInstallPrompt } from "../SuppressAndroidInstallPrompt";

import { PageManifestCrisisBanner } from "../Banner/CrisisBanner";
import { isCrisisBannerPreview } from "../Banner/helpers";
import Breadcrumbs, { getBreadcrumbsContent } from "../Breadcrumbs";
import { InAppMessagingService } from "../InAppMessagingService";
import { PrefetchContext, PrefetchedContent } from "../prefetch";
import RootWrapper from "../RootWrapper";
import { configNRLogger } from "../../client/configNR";

//TODO: Type this exactly to match what tal-core passes on.
export interface AppProps {
  title: string;
  actionBar?: Window["oetal"]["pageData"]["actionBar"];
  authenticated?: boolean;
  background?: "gray" | "white" | "secondary";
  channel?: string;
  children?: React.ReactNode;
  prefetchContent?: Record<string, PrefetchedContent>;
  noSeed?: boolean;
  platform?: string;
  presets?: string[];
  showHeader?: boolean | "unauth" | "scoped";
  showNativeAppAd?: boolean;
  crisisBanner?: PageManifestCrisisBanner;
  storyMode?: boolean;
}

const App = ({
  actionBar,
  channel,
  prefetchContent = {},
  platform,
  presets,
  showHeader = true,
  showNativeAppAd = true,
  crisisBanner = "none",
  title,
  storyMode = false,
}: AppProps) => {
  useEffect(() => {
    // Needs to be done here to ensure it has access to window.oetal
    configNRLogger();
  }, []);

  const isKraken =
    platform === "kraken" || (presets && presets.includes("kraken"));
  const isNativeChannel = channel === "native";
  const breadcrumbsContent = getBreadcrumbsContent(prefetchContent);
  const isPreview = typeof window !== "undefined" && isCrisisBannerPreview();
  let crisisBannerPosition = crisisBanner;

  if (isPreview) {
    crisisBannerPosition = "top";
  }

  const AppContent = (
    <PrefetchContext.Provider value={prefetchContent}>
      <TrustPilotModal />
      <ReviewAlertFooterService />
      <InAppMessagingService />
      {!showNativeAppAd && <SuppressAndroidInstallPrompt />}
      {crisisBannerPosition !== "float" && !isNativeChannel && (
        <CrisisBanner position={crisisBannerPosition} />
      )}

      <SkipLink target="#oetal-application-root" />

      {isKraken ? (
        <KrakenAppContent
          title={title}
          showHeader={showHeader}
          actionBar={actionBar}
          crisisBanner={crisisBannerPosition}
          isNative={isNativeChannel}
        />
      ) : (
        <UnauthAppContent
          actionBar={actionBar}
          showHeader={showHeader}
          title={title}
          crisisBanner={crisisBannerPosition}
          isNative={isNativeChannel}
        />
      )}
      {crisisBannerPosition !== "top" && !isNativeChannel && (
        <CrisisBanner position={crisisBannerPosition} />
      )}
      {breadcrumbsContent && <Breadcrumbs data={breadcrumbsContent} />}
    </PrefetchContext.Provider>
  );

  return storyMode ? AppContent : <RootWrapper>{AppContent}</RootWrapper>;
};

export { App };
